import { useEffect, useState } from 'react';
import { FeaturebaseFunction } from 'shared/services/featurebase/types';

type ScriptStatus = 'loading' | 'ready' | 'error';

export const useFeaturebaseScript = () => {
  const [status, setStatus] = useState<ScriptStatus>('loading');

  useEffect(() => {
    // Check if Featurebase already exists
    if (window.Featurebase) {
      setStatus('ready');
      return;
    }

    // Check if script already exists
    const existingScript = document.getElementById('featurebase-sdk');
    if (existingScript) {
      setStatus('ready');
      return;
    }

    // Set up the Featurebase queue function before script loads
    if (typeof window.Featurebase !== 'function') {
      window.Featurebase = function () {
        (window.Featurebase!.q = window.Featurebase!.q || []).push(arguments);
      } as unknown as FeaturebaseFunction;
    }

    // Create script element
    const script = document.createElement('script');
    script.id = 'featurebase-sdk';
    script.src = 'https://do.featurebase.app/js/sdk.js';
    script.async = true;

    script.onload = () => {
      setStatus('ready');
    };

    script.onerror = () => {
      setStatus('error');
    };

    document.head.appendChild(script);

    // No cleanup - script persists for app lifetime
  }, []);

  return {
    status,
    isReady: status === 'ready',
    isError: status === 'error',
  };
};
